import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { ResponseData } from "../common"
import { PriceDropAlertRequestData } from "../priceDropAlert"

export interface SoftLoginRequestParams {
  emailId: string
  propertyId?: string
  createFavouriteList?: boolean
  userPriceDropAlertRequest?: PriceDropAlertRequestData | null
  messageToHost?: boolean
  softLoginFrom?: "APPLE" | "GOOGLE" | null
}
export interface SoftLoginRequest extends Partial<AxiosRequestConfig> {
  params: SoftLoginRequestParams
}

interface SoftLoginResponseData extends ResponseData {
  message: string
  userId: number
  status: number
  softLogin: boolean
  priceDropAlertId?: string | null
}

export interface SoftLoginResponse extends AxiosResponse {
  data: SoftLoginResponseData
}

export function softLoginAPI(
  { params }: SoftLoginRequest,
  axiosInstance: AxiosInstance,
) {
  return axiosInstance({
    data: params,
    method: "POST",
    url: `/auth/soft-login`,
  }) as Promise<SoftLoginResponse>
}
